import { render, staticRenderFns } from "./BookingPaymentsTypeComponent.vue?vue&type=template&id=7abc3004"
import script from "./BookingPaymentsTypeComponent.vue?vue&type=script&lang=js"
export * from "./BookingPaymentsTypeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports